export const CIRCULAR_EXPANSION_SLICE_TYPE = 'homecircularexpansion';
